import * as firebase from 'firebase'

// Healthcare Experience Module

const state = {
  directPaidHours: [],
  directHours: [],
  indirectHours: [],
  volunteerHours: [],
  communityServiceHours : [],
  certifications: [],
};

const mutations = {
// Set Direct Paid Experience Hours on login
setdirectPaidHours(state, payload) {
  state.directPaidHours = payload
},
// Set Direct Experience Hours on login
setdirectHours(state, payload) {
  state.directHours = payload
},
// Set Indirect Experience Hours on login
setindirectHours(state, payload) {
  state.indirectHours = payload
},
// Set Volunteer Experience Hours on login
setvolunteerHours(state, payload) {
  state.volunteerHours = payload
},
// Set Community Service Experience Hours on login
setcommunityServiceHours(state, payload) {
  state.communityServiceHours = payload
},
setUserCertification (state, payload) {
  state.certifications = payload
},

// Add Direct Paid Patient Hours Info
addDirectPaidHealthCareExperienceInfo(state, payload) {
  state.directPaidHours.push(payload)
},
// Log Direct Paid Hours
logDirectPaidHours(state, payload) {
  for(var i=0; i < state.directPaidHours.length; i++) {
    if(state.directPaidHours[i].id === payload.directPaidHours_id) {
      state.directPaidHours[i].logged_hours.push(payload)
    }
  }
},
// Remove Direct Paid Patient Hours Info
removeDirectPaidHours(state, payload) {
  state.directPaidHours.forEach(directPaidHours => {
    if(directPaidHours.id === payload) {
      state.directPaidHours.splice(state.directPaidHours.indexOf(directPaidHours), 1)
    }
  })
},

// Remove Logged Direct Paid Hours
removeLoggedDirectPaidHours(state, payload) {
  for(var i=0; i < state.directPaidHours.length; i++) {
    if(state.directPaidHours[i].id === payload.directPaidHoursId) {

      for(var c=0; c < state.directPaidHours[i].logged_hours.length; c++) {
        if(state.directPaidHours[i].logged_hours[c].id === payload.loggedHourId) {
          var index = state.directPaidHours[i].logged_hours.indexOf(state.directPaidHours[i].logged_hours[c])
          state.directPaidHours[i].logged_hours.splice(index, 1)
        }
      }
    }
  }
},



// Add Direct Patient Hours Info
addDirectHealthCareExperienceInfo(state, payload) {
  state.directHours.push(payload)
},
// Add Certifications
addCertification (state, payload) {
  state.certifications.push(payload)
},
// Remove Certification
removeCertification (state, payload) {
  state.certifications.forEach(certification => {
    if(certification.id === payload.certificationId) {
      state.certifications.splice(state.certifications.indexOf(certification), 1)
    }
  })
},
// Log Direct Patient Hours Info
logDirectHours(state, payload) {
  for(var i=0; i < state.directHours.length; i++) {
    if(state.directHours[i].id === payload.directHours_id) {
      state.directHours[i].logged_hours.push(payload)
    }
  }
},
// Remove Direct Patient Hours Info
removeDirectHours(state, payload) {
  state.directHours.forEach(directHours => {
    if(directHours.id === payload) {
      state.directHours.splice(state.directHours.indexOf(directHours), 1)
    }
  })
},

// Remove Logged Direct Hours
removeLoggedDirectHours(state, payload) {
  for(var i=0; i < state.directHours.length; i++) {
    if(state.directHours[i].id === payload.directHoursId) {

      for(var c=0; c < state.directHours[i].logged_hours.length; c++) {
        if(state.directHours[i].logged_hours[c].id === payload.loggedHourId) {
          var index = state.directHours[i].logged_hours.indexOf(state.directHours[i].logged_hours[c])
          state.directHours[i].logged_hours.splice(index, 1)
        }
      }
    }
  }
},


// Add Indirect Patient Hours Info
addIndirectHealthCareExperienceInfo(state, payload) {
  state.indirectHours.push(payload)
},
// Log Indirect Patient Hours Info
logIndirectHours(state, payload) {
  for(var i=0; i < state.indirectHours.length; i++) {
    if(state.indirectHours[i].id === payload.indirectHours_id) {
      state.indirectHours[i].logged_hours.push(payload)
    }
  }
},
// Remove Indirect Patient Hours Info
removeIndirectHours(state, payload) {
  state.indirectHours.forEach(indirectHours => {
    if(indirectHours.id === payload) {
      state.indirectHours.splice(state.indirectHours.indexOf(indirectHours), 1)
    }
  })
},

// Remove Logged Indirect Hours
removeLoggedIndirectHours(state, payload) {
  for(var i=0; i < state.indirectHours.length; i++) {
    if(state.indirectHours[i].id === payload.indirectHoursId) {

      for(var c=0; c < state.indirectHours[i].logged_hours.length; c++) {
        if(state.indirectHours[i].logged_hours[c].id === payload.loggedHourId) {
          var index = state.indirectHours[i].logged_hours.indexOf(state.indirectHours[i].logged_hours[c])
          state.indirectHours[i].logged_hours.splice(index, 1)
        }
      }
    }
  }
},

// Add Volunteer Hours Info
addVolunteerExperienceInfo(state, payload) {
  state.volunteerHours.push(payload)
},
// Log Volunteer Hours
logVolunteerHours(state, payload) {
  for(var i=0; i < state.volunteerHours.length; i++) {
    if(state.volunteerHours[i].id === payload.volunteerHours_id) {
      state.volunteerHours[i].logged_hours.push(payload)
    }
  }
},
// Remove Volunteer Hours Info
removeVolunteerHours(state, payload) {
  state.volunteerHours.forEach(volunteerHours => {
    if(volunteerHours.id === payload) {
      state.volunteerHours.splice(state.volunteerHours.indexOf(volunteerHours), 1)
    }
  })
},

// Remove Logged Volunteer Hours
removeLoggedVolunteerHours(state, payload) {
  for(var i=0; i < state.volunteerHours.length; i++) {
    if(state.volunteerHours[i].id === payload.volunteerHoursId) {

      for(var c=0; c < state.volunteerHours[i].logged_hours.length; c++) {
        if(state.volunteerHours[i].logged_hours[c].id === payload.loggedHourId) {
          var index = state.volunteerHours[i].logged_hours.indexOf(state.volunteerHours[i].logged_hours[c])
          state.volunteerHours[i].logged_hours.splice(index, 1)
        }
      }
    }
  }
},

// Add Community Service  Info
addCommunityServiceExperienceInfo(state, payload) {
  state.communityServiceHours.push(payload)
},

// Log Community Service Hours
logCommunityServiceHours(state, payload) {
  for(var i=0; i < state.communityServiceHours.length; i++) {
    if(state.communityServiceHours[i].id === payload.communityServiceHours_id) {
      state.communityServiceHours[i].logged_hours.push(payload)
    }
  }
},
// Remove Community Service Hours
removeCommunityServiceHours(state, payload) {
  state.communityServiceHours.forEach(communityServiceInfo => {
    if(communityServiceInfo.id === payload) {
      state.communityServiceHours.splice(state.communityServiceHours.indexOf(communityServiceInfo), 1)
    }
  })
},
// Remove Logged Community Service Hours
removeLoggedCommunityServiceHours(state, payload) {
  for(var i=0; i < state.communityServiceHours.length; i++) {
    if(state.communityServiceHours[i].id === payload.communityServiceHours_id) {

      for(var c=0; c < state.communityServiceHours[i].logged_hours.length; c++) {
        if(state.communityServiceHours[i].logged_hours[c].id === payload.loggedHourId) {
          var index = state.communityServiceHours[i].logged_hours.indexOf(state.communityServiceHours[i].logged_hours[c])
          state.communityServiceHours[i].logged_hours.splice(index, 1)
        }
      }
    }
  }
},

// Logout Colleges
setLogoutUser(state, payload = null) {
  state.directPaidHours = [],
  state.directHours = [],
  state.indirectHours = [],
  state.volunteerHours = [],
  state.communityServiceHours = [],
  state.certifications = []

}

};

const actions = {
// Add Certification
setAddCertification({commit, getters}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/certifications/').push(payload)
  .then((data)=> {
    const key = data.key
    commit('addCertification', {
      ...payload,
      id:key,
    })
  })
},
// Remove Certification
setRemoveCertification({commit, getters}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/certifications/').child(payload.certificationId).remove()
  .then((data) => {
    commit('removeCertification', payload)
  })
},
// Edit Certification
setEditCertification({commit, getters}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/certifications/').child(payload.certificationId).update(payload)
  .then((data) => {
  })
},
// Add Healthcare Experience Hours Info to Database
setHealthcareExperienceInfo ({commit, getters, dispatch}, payload) {

  // Send Direct Paid Hours to database
  if(payload.experience_type === 'Direct Paid Patient Care Hours') {
  firebase.database().ref('/users/' + getters.user.uid + '/direct_paid_patient_experience/').push(payload)
    .then((data) => {
      const key = data.key
      commit('addDirectPaidHealthCareExperienceInfo', {
        ...payload,
        id:key,
        logged_hours : []
      })
    })
  }
  // Send Direct Hours to database
  if(payload.experience_type === 'Direct Patient Care Hours') {
    firebase.database().ref('/users/' + getters.user.uid + '/direct_patient_experience/').push(payload)
      .then((data) => {
        const key = data.key
        commit('addDirectHealthCareExperienceInfo', {
          ...payload,
          id:key,
          logged_hours : []
        })
      })
    }
    // indirect Hours to database
    if(payload.experience_type === 'Indirect Patient Hours') {
      firebase.database().ref('/users/' + getters.user.uid + '/indirect_patient_experience/').push(payload)
        .then((data) => {
          const key = data.key
          commit('addIndirectHealthCareExperienceInfo', {
            ...payload,
            id:key,
            logged_hours : []
          })
        })
    }
    // Volunteer Hours to database
    if(payload.experience_type === 'Volunteer') {
      firebase.database().ref('/users/' + getters.user.uid + '/volunteer_experience/').push(payload)
        .then((data) => {
          const key = data.key
          commit('addVolunteerExperienceInfo', {
            ...payload,
            id:key,
            logged_hours : []
          })
        })
    }
      // Community Service Hours to database
      if(payload.experience_type === 'Community Service') {
        firebase.database().ref('/users/' + getters.user.uid + '/community_service_experience/').push(payload)
          .then((data) => {
            const key = data.key
            commit('addCommunityServiceExperienceInfo', {
              ...payload,
              id:key,
              logged_hours : []
            })
          })
      }

      dispatch('setupUserData', firebase.auth().currentUser, { root: true })
},



////// Direct Paid Hours

// Log Direct Paid Hours Info
setLogDirectPaidHours({commit, getters, dispatch}, payload) {

  firebase.database().ref('/users/' + getters.user.uid + '/direct_paid_patient_experience/').child(payload.directPaidHours_id).child('logged_hours').push(payload)
  .then((data) => {
    const key = data.key
    commit('logDirectPaidHours', {
      ...payload,
      id:key
    })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
// Edit Direct Paid Experience Info
setEditDirectPaidHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/direct_paid_patient_experience/' + payload.directPaidExperienceId).update(payload)
  .then((data) => {
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
// Remove Direct Paid Experience Info
setRemoveDirectPaidHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/direct_paid_patient_experience/').child(payload).remove()
  .then((data) => {
    commit('removeDirectPaidHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Edit Logged Direct Paid Hours Info
setEditLoggedDirectPaidHours({commit, getters, dispatch}, payload){
  firebase.database().ref('/users/' + getters.user.uid + '/direct_paid_patient_experience/' + payload.directPaidHoursId + '/logged_hours/').child(payload.loggedHourId).update(payload)
  .then((data) => {
    // const key = data.key
    // commit('editUserEvaluation', {
    //   ...payload,
    //   id:key
    // })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Remove Logged Direct Paid Hours Info
setRemoveLoggedDirectPaidHours({commit, getters, dispatch}, payload){
  firebase.database().ref('/users/' + getters.user.uid + '/direct_paid_patient_experience/' + payload.directPaidHoursId + '/logged_hours/').child(payload.loggedHourId).remove()
  .then((data) => {
    commit('removeLoggedDirectPaidHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},


////// Direct  Hours

// Log Direct Hours
setLogDirectHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/direct_patient_experience/').child(payload.directHours_id).child('logged_hours').push(payload)
  .then((data) => {
    const key = data.key
    commit('logDirectHours', {
      ...payload,
      id:key
    })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
// Edit Direct Experience Info
setEditDirectHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/direct_patient_experience/' + payload.directExperienceId).update(payload)
  .then((data) => {
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    // const key = data.key
    // commit('editUserEvaluation', {
    //   ...payload,
    //   id:key
    // })
  })
},
// Remove Direct Experience Hours Info
setRemoveDirectHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/direct_patient_experience/').child(payload).remove()
  .then((data) => {
    commit('removeDirectHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Edit Logged Direct Paid Hours
setEditLoggedDirectHours({commit, getters, dispatch}, payload){
  firebase.database().ref('/users/' + getters.user.uid + '/direct_patient_experience/' + payload.directHoursId + '/logged_hours/').child(payload.loggedHourId).update(payload)
  .then((data) => {
    // const key = data.key
    // commit('editUserEvaluation', {
    //   ...payload,
    //   id:key
    // })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Remove Logged Direct Paid Hours
setRemoveLoggedDirectHours({commit, getters, dispatch}, payload){
  firebase.database().ref('/users/' + getters.user.uid + '/direct_patient_experience/' + payload.directHoursId + '/logged_hours/').child(payload.loggedHourId).remove()
  .then((data) => {
    commit('removeLoggedDirectHours', payload)
  })
},


/////// Indirect Hours

// Log Indirect Hours
setLogIndirectHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/indirect_patient_experience/').child(payload.indirectHours_id).child('logged_hours').push(payload)
  .then((data) => {
    const key = data.key
    commit('logIndirectHours', {
      ...payload,
      id:key
    })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
// Edit Indirect Experience Info
setEditIndirectHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/indirect_patient_experience/' + payload.indirectExperienceId).update(payload)
  .then((data) => {
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    // const key = data.key
    // commit('editUserEvaluation', {
    //   ...payload,
    //   id:key
    // })
  })
},
// Remove Indirect Experience Hours Info
setRemoveIndirectHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/indirect_patient_experience/').child(payload).remove()
  .then((data) => {
    commit('removeIndirectHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Edit Logged Indirect Hours
setEditLoggedIndirectHours({commit, getters, dispatch}, payload){
  firebase.database().ref('/users/' + getters.user.uid + '/indirect_patient_experience/' + payload.indirectHoursId + '/logged_hours/').child(payload.loggedHourId).update(payload)
  .then((data) => {
    // const key = data.key
    // commit('editUserEvaluation', {
    //   ...payload,
    //   id:key
    // })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Remove Logged Indirect Hours
setRemoveLoggedIndirectHours({commit, getters, dispatch}, payload){
  firebase.database().ref('/users/' + getters.user.uid + '/indirect_patient_experience/' + payload.indirectHoursId + '/logged_hours/').child(payload.loggedHourId).remove()
  .then((data) => {
    commit('removeLoggedIndirectHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},


///////// Volunteer Hours

// Log Volunteer Hours
setLogVolunteerHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/volunteer_experience/').child(payload.volunteerHours_id).child('logged_hours').push(payload)
  .then((data) => {
    const key = data.key
    commit('logVolunteerHours', {
      ...payload,
      id:key
    })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
// Edit Volunteer Experience Info
setEditVolunteerHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/volunteer_experience/' + payload.volunteerExperienceId).update(payload)
  .then((data) => {
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
    // const key = data.key
    // commit('editUserEvaluation', {
    //   ...payload,
    //   id:key
    // })
  })
},

// Remove Volunteer Experience Hours Info
setRemoveVolunteerHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/volunteer_experience/').child(payload).remove()
  .then((data) => {
    commit('removeVolunteerHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Edit Logged Volunteer Hours
setEditLoggedVolunteerHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/volunteer_experience/' + payload.volunteerHoursId + '/logged_hours/').child(payload.loggedHourId).update(payload)
  .then((data) => {
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Remove Logged Volunteer Hours
setRemoveLoggedVolunteerHours({commit, getters, dispatch}, payload){
  firebase.database().ref('/users/' + getters.user.uid + '/volunteer_experience/' + payload.volunteerHoursId + '/logged_hours/').child(payload.loggedHourId).remove()
  .then((data) => {
    commit('removeLoggedVolunteerHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},

// Log Community Service Hours
setLogCommunityServiceHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/community_service_experience/').child(payload.communityServiceHours_id).child('logged_hours').push(payload)
  .then((data) => {
    const key = data.key
    commit('logCommunityServiceHours', {
      ...payload,
      id:key
    })
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
// Remove Community Service Experience Info
setRemoveCommunityServiceHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/community_service_experience/').child(payload).remove()
  .then((data) => {
    commit('removeCommunityServiceHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
// Edit Community ServiceInfo
setEditcommunityServiceInfo({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/community_service_experience/' + payload.communityServiceHours_id).update(payload)
  .then((data) => {
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
setRemoveLoggedCommunityServiceHours({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/community_service_experience/' + payload.communityServiceHours_id + '/logged_hours/').child(payload.loggedHourId).remove()
  .then((data) => {
    commit('removeLoggedCommunityServiceHours', payload)
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
setEditLoggedCommunityServiceHour({commit, getters, dispatch}, payload) {
  firebase.database().ref('/users/' + getters.user.uid + '/community_service_experience/' + payload.communityServiceHours_id  + '/logged_hours/').child(payload.loggedHourId).update(payload)
  .then((data) => {
    dispatch('setupUserData', firebase.auth().currentUser, { root: true })
  })
},
};

const getters = {
// Certifications
certificationsInfo(state) {
  return state.certifications
},
certificationInfo(state) {
  return (id) => {
    return state.certifications.find((certification) => {
      return certification.id === id
    })
  }
},
// Direct Paid Patient Hours List
directPaidPatientInfo(state) {
  return state.directPaidHours
},

// Direct Paid Info
directPaidHoursInfo(state) {
  return (id) => {
    return state.directPaidHours.find((directPaidHour) => {
      return directPaidHour.id === id
    })
  }
},
// Total Direct Paid Hours
totalDirectPaidHours(state) {
  var sum = 0
  for(var i=0; i < state.directPaidHours.length; i++) {
    for(var s=0; s < state.directPaidHours[i].logged_hours.length; s++) {
     sum += parseFloat(state.directPaidHours[i].logged_hours[s].hours)
    }
  }
  return sum
},

// Direct Patient Hours List
directPatientInfo(state) {
  return state.directHours
},
// Direct Hours Info
directHoursInfo(state) {
  return (id) => {
    return state.directHours.find((directHour) => {
      return directHour.id === id
    })
  }
},
// Total Direct Patient Hours
totalDirectHours(state) {
  var sum = 0
  for(var i=0; i < state.directHours.length; i++) {
    for(var s=0; s < state.directHours[i].logged_hours.length; s++) {
      sum += parseFloat(state.directHours[i].logged_hours[s].hours)
    }
  }
  return sum
},
// Indirect Patient Hours List
indirectPatientInfo(state) {
  return state.indirectHours
},
// Direct Paid Info
indirectHoursInfo(state) {
  return (id) => {
    return state.indirectHours.find((indirectHour) => {
      return indirectHour.id === id
    })
  }
},
// Total Indirect Patient Hours
totalIndirectHours(state) {
  var sum = 0
  for(var i=0; i < state.indirectHours.length; i++) {
    for(var s=0; s < state.indirectHours[i].logged_hours.length; s++) {
      sum += parseFloat(state.indirectHours[i].logged_hours[s].hours)
    }
  }
  return sum
},
// Volunteer Patient Info
volunteerPatientInfo(state) {
  return state.volunteerHours
},
// Volunteer Info
volunteerHoursInfo(state) {
  return (id) => {
    return state.volunteerHours.find((volunteerHour) => {
      return volunteerHour.id === id
    })
  }
},
// Total Volunteer Patient Hours
totalVolunteerHours(state) {
  var sum = 0
  for(var i=0; i < state.volunteerHours.length; i++) {
    for(var s=0; s < state.volunteerHours[i].logged_hours.length; s++) {
      sum += parseFloat(state.volunteerHours[i].logged_hours[s].hours)
    }
  }
  return sum
},
// Community Service Info
communityServiceInfo(state) {
  return state.communityServiceHours
},
// Community Service Info Detail
communityServiceHoursDetail(state) {
  return (id) => {
    return state.communityServiceHours.find((communityServiceHour) => {
      return communityServiceHour.id === id
    })
  }
},
// Total Community Service Hours
totalCommunityServiceHours(state) {
  var sum = 0
  for(var i=0; i < state.communityServiceHours.length; i++) {
    for(var s=0; s < state.communityServiceHours[i].logged_hours.length; s++) {
      sum += parseFloat(state.communityServiceHours[i].logged_hours[s].hours)
    }
  }
  return sum
},
// Total Healthcare Hours
totalHealthcareExperienceHours(state, getters) {
  var totalHealthHours = parseFloat(getters.totalDirectPaidHours) + parseFloat(getters.totalDirectHours) + parseFloat(getters.totalIndirectHours) + parseFloat(getters.totalVolunteerHours) + parseFloat(getters.totalCommunityServiceHours)
  return totalHealthHours
},
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/healthcareexperience.js